import path from 'ramda/src/path'

export default function extendBoundsForLabels({ bounds, markups }) {
  const labels = markups.filter(m => m.type === 'label')

  for (const label of labels) {
    const rect = path(['overlay', 'rectangle'], label)
    if (!rect) continue

    bounds.extend(rect.getBounds().getNorthEast())
    bounds.extend(rect.getBounds().getSouthWest())
  }
  return bounds
}



// WEBPACK FOOTER //
// ./src/helpers/markups/extendBoundsForLabels.js